// eslint-disable-next-line
export const UpdateStatus = Object.freeze({
  Loading: 0,
  Success: 1,
  Rejected: 2,
  ErrorApprove: 3,
  ErrorReject: 4,
  Hidden: 5
});

export const LoadingStatus = Object.freeze({
  Loading: 0,
  Success: 1,
  Error: 2,
  Initial: 3
});
